import { Ripple } from 'react-css-spinners'
import './Loading.scss'

const Loading = (): JSX.Element => {
  return (
    <div className="Loading flex items-center justify-center">
      <div className="">
        <Ripple size={100} color="var(--color-primary)" />
      </div>
    </div>
  )
}

export default Loading
